import { Pill } from '@iwoca/orion';
import { t } from '@lingui/macro';
import { useLocale } from 'hooks/useLocale';
import { TWhatsNewNotification } from 'lendingApi/whatsNew';
import styles from './ContentDetails.module.css';

type TProps = {
  data: TWhatsNewNotification;
};

export const ContentDetails = ({
  data: { type, title, released_at },
}: TProps) => {
  const { i18n } = useLocale();

  const renderType = (type: TWhatsNewNotification['type']) => {
    switch (type) {
      case 'event':
        return t`Event`;
      case 'improvement':
        return t`Improvement`;
      case 'feature':
        return t`Feature`;
    }
  };

  return (
    <div className={styles.contentDetails}>
      <Pill className={styles.type}>{renderType(type)}</Pill>
      <p className={styles.title}>{title}</p>
      <span className={styles.dateCreated}>
        {i18n.date(released_at, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })}
      </span>
    </div>
  );
};
